
(function () {
  const REGISTRY = {};
  const INSTANCES = new WeakMap();
  function register(type, mod) {
    REGISTRY[type] = mod;
  }

  function initSection(el) {
    if (!el || INSTANCES.has(el)) return;
    const type = el.dataset.sectionType;
    const mod = REGISTRY[type];
    if (!mod || typeof mod.init !== "function") return;

    const api = mod.init(el) || {};
    INSTANCES.set(el, { mod, api });
  }

  function unloadSection(el) {
    const inst = INSTANCES.get(el);
    if (!inst) return;
    try {
      (inst.api.unload || inst.mod.unload)?.(el);
    } catch (err) {
      console.error("[sections] unload error:", err);
    }
    INSTANCES.delete(el);
  }

  function initAll(scope = document) {
    scope.querySelectorAll("[data-section-type]").forEach(initSection);
  }

  // DOM ready
  document.addEventListener("DOMContentLoaded", () => initAll());

  // Theme Editor: carregar/descarregar seções dinamicamente
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:unload", (e) => {
    e.target.querySelectorAll("[data-section-type]").forEach(unloadSection);
  });

  // Theme Editor: seleção de bloco
  document.addEventListener("shopify:block:select", (e) => {
    const sectionEl = e.target.closest("[data-section-type]");
    if (!sectionEl) return;
    const inst = INSTANCES.get(sectionEl);
    inst?.mod?.blockSelect?.(sectionEl, e);
  });
  document.addEventListener("shopify:block:deselect", (e) => {
    const sectionEl = e.target.closest("[data-section-type]");
    if (!sectionEl) return;
    const inst = INSTANCES.get(sectionEl);
    inst?.mod?.blockDeselect?.(sectionEl, e);
  });

  window.DMSections = { register, initAll };

  const on = (el, ev, fn, opt) => (el && el.addEventListener(ev, fn, opt), () => el && el.removeEventListener(ev, fn, opt));
  const raf = (fn) => requestAnimationFrame(fn);

  register("compre-o-look", {
    init(root) {
      const dots = Array.from(root.querySelectorAll(".stl-dot"));
      const cards = Array.from(root.querySelectorAll(".stl-card"));
      const prev = root.querySelector(".stl-prev");
      const next = root.querySelector(".stl-next");

      const order = cards.map((c) => +c.dataset.cardIndex);
      let i = -1;

      const setAria = (el, key, val) => el?.setAttribute?.(key, String(val));

      function updateButtons() {
        const enabled = i >= 0;
        if (prev) prev.disabled = !enabled || i <= 0;
        if (next) next.disabled = !enabled || i >= order.length - 1;
      }

      function select(byIndex) {
        if (byIndex < 0 || byIndex > order.length - 1) return;
        i = byIndex;
        const activeCardIndex = order[i];

        dots.forEach((d, k) => setAria(d, "aria-current", k === activeCardIndex));
        cards.forEach((c) =>
          c.classList.toggle(
            "is-active",
            +c.dataset.cardIndex === activeCardIndex
          )
        );
        updateButtons();
      }

      const listeners = [];

      // dots
      dots.forEach((d, idx) => {
        const hasCard = order.includes(idx);
        if (!hasCard) {
          setAria(d, "aria-disabled", true);
          d.style.opacity = 0.6;
          d.style.cursor = "not-allowed";
          return;
        }
        const h = () => select(order.indexOf(idx));
        listeners.push(on(d, "click", h));
      });

      // prev/next
      if (prev) listeners.push(on(prev, "click", () => select(i - 1)));
      if (next) listeners.push(on(next, "click", () => select(i + 1)));

      if (order.length) select(0);
      else updateButtons();

      return {
        unload() {
          listeners.forEach((off) => off && off());
        },
      };
    },

    blockSelect(root, e) {
      const blockId = e.detail?.blockId;
      if (!blockId) return;

      const li = root.querySelector(`[data-block-id="${blockId}"]`);
      if (!li) return;

      const dot = li.querySelector(".stl-dot");
      if (!dot) return;

      dot.click();
      root.querySelector(".stl-card.is-active")?.scrollIntoView?.({
        block: "nearest",
        behavior: "smooth",
      });
    },
  });

  // ======================================================
  // MÓDULO 2: Reviews Slider (data-section-type="reviews-slider")
  // ======================================================
  register("reviews-slider", {
    init(root) {
      const track = root.querySelector("[data-track]");
      const viewport = root.querySelector("[data-viewport]");
      const slides = Array.from(root.querySelectorAll("[data-slide]"));
      const controls = root.querySelector(".reviews__slideshow-controls");
      if (!track || !viewport || slides.length === 0) return;

      let index = 0;
      const autoplay = String(root.dataset.autoplay).toLowerCase() === "true";
      const interval = parseInt(root.dataset.interval || "5000", 10) || 5000;
      let timer = null;

      const listeners = [];

      const slideWidth = () => viewport.getBoundingClientRect().width || 0;

      function syncSlideWidths() {
        const w = slideWidth();
        slides.forEach((s) => (s.style.minWidth = `${w}px`));
      }

      function go(to) {
        if (!slides.length) return;
        index = ((to % slides.length) + slides.length) % slides.length;
        const x = -(index * slideWidth());
        track.style.transform = `translateX(${x}px)`;
        if (controls) {
          controls.querySelectorAll('[ref="dots[]"]').forEach((d, i) => {
            d.setAttribute("aria-selected", i === index ? "true" : "false");
          });
        }
      }

      const next = () => go(index + 1);
      const prev = () => go(index - 1);

      if (controls) {
        const clickHandler = (e) => {
          const btn = e.target.closest("[ref]");
          if (!btn) return;
          const ref = btn.getAttribute("ref");
          if (ref === "next") {
            e.preventDefault();
            next();
          } else if (ref === "previous") {
            e.preventDefault();
            prev();
          } else if (ref === "dots[]") {
            e.preventDefault();
            const dots = Array.from(controls.querySelectorAll('[ref="dots[]"]'));
            const i = dots.indexOf(btn);
            if (i > -1) go(i);
          }
        };
        listeners.push(on(controls, "click", clickHandler));
      }

      let resizeRAF = null;
      const onResize = () => {
        if (resizeRAF) cancelAnimationFrame(resizeRAF);
        resizeRAF = raf(() => {
          syncSlideWidths();
          go(index);
        });
      };
      listeners.push(on(window, "resize", onResize, { passive: true }));

      syncSlideWidths();
      go(0);

      // autoplay + pausas
      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      const start = () => {
        stop();
        if (autoplay && slides.length > 1) {
          timer = setInterval(next, interval);
        }
      };

      if (autoplay && slides.length > 1) {
        start();
        listeners.push(on(root, "mouseenter", stop));
        listeners.push(on(root, "mouseleave", start));
        listeners.push(on(root, "focusin", stop));
        listeners.push(on(root, "focusout", start));
        listeners.push(on(window, "visibilitychange", () => (document.hidden ? stop() : start())));
      }

      return {
        unload() {
          stop();
          listeners.forEach((off) => off && off());
        },
      };
    },

    blockSelect(root, e) {
      const blockId = e.detail?.blockId;
      if (!blockId) return;

      const track = root.querySelector("[data-track]");
      const viewport = root.querySelector("[data-viewport]");
      const slides = Array.from(root.querySelectorAll("[data-slide]"));
      const controls = root.querySelector(".reviews__slideshow-controls");
      if (!track || !viewport || slides.length === 0) return;

      const slideEl = root.querySelector(`[data-block-id="${blockId}"]`);
      if (!slideEl) return;

      const idx = slides.indexOf(slideEl);
      if (idx === -1) return;

      const w = viewport.getBoundingClientRect().width || 0;
      slides.forEach((s) => (s.style.minWidth = `${w}px`));
      track.style.transform = `translateX(${-idx * w}px)`;
      if (controls) {
        controls.querySelectorAll('[ref="dots[]"]').forEach((d, i) => {
          d.setAttribute("aria-selected", i === idx ? "true" : "false");
        });
      }

      slideEl.scrollIntoView?.({ block: "nearest", behavior: "smooth" });
    },
  });

  // ======================================================
  // MÓDULO 3: Texto de Impacto (data-section-type="impact-text")
  // ======================================================
  register("impact-text", {
    init(root) {
      const items = Array.from(root.querySelectorAll(".dropmeta-item"));
      const cleanups = [];
      const activeTweens = new Map();

      // tween com cancel
      function tween(seconds, step, done) {
        const start = performance.now();
        let rafId = null;
        function tick(t) {
          const p = Math.min(1, (t - start) / (seconds * 1000));
          step(p);
          if (p < 1) rafId = requestAnimationFrame(tick);
          else done && done();
        }
        rafId = requestAnimationFrame(tick);
        return () => rafId && cancelAnimationFrame(rafId);
      }

      function startCountUp(item) {
        if (!item.dataset.countup) return;
        const span = item.querySelector(".dropmeta-title__inner");
        if (!span) return;

        const original = (span.textContent || "").trim();
        const m = original.match(/\d[\d.,\s]*/);
        if (!m) return;

        const sample = m[0]; // parte numérica encontrada
        const target = parseInt(sample.replace(/[^\d]/g, ""), 10);
        if (!Number.isFinite(target)) return;

        const before = original.slice(0, m.index);
        const after = original.slice(m.index + sample.length);

        // tenta preservar separador do original (., ou espaço)
        const sep = (sample.match(/[.,\s]/) || [])[0] || "";
        const groupFormat = (n) => {
          let s = String(n);
          if (!sep) return s;
          let out = "";
          while (s.length > 3) {
            out = sep + s.slice(-3) + out;
            s = s.slice(0, -3);
          }
          return s + out;
        };

        const dur = parseFloat(item.dataset.duration || "2");
        const cancel = tween(dur, (p) => {
          const val = Math.round(target * p);
          span.textContent = before + (p < 1 ? groupFormat(val) : sample) + after;
        });
        activeTweens.set(item, cancel);
      }

      if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add("is-visible");
                startCountUp(e.target);
                io.unobserve(e.target);
              }
            });
          },
          { rootMargin: "0px 0px -10% 0px", threshold: 0.2 }
        );
        items.forEach((el) => io.observe(el));
        cleanups.push(() => io.disconnect());
      } else {
        // fallback
        items.forEach((el) => {
          el.classList.add("is-visible");
          startCountUp(el);
        });
      }

      return {
        unload() {
          cleanups.forEach((fn) => fn && fn());
          activeTweens.forEach((cancel) => cancel && cancel());
          activeTweens.clear();
        },
      };
    },
  });

  // ======================================================
// MÓDULO 4: Hotspots (data-section-type="hotspot")
// ======================================================
window.DMSections.register("hotspot", {
  init(root) {
    const offs = [];

    // Media query para detectar mobile
    const mq = window.matchMedia("(max-width: 749px)");
    const isMobile = () => mq.matches;

    // Modal (mobile)
    const modal = root.querySelector(".hs-modal");
    const modalOpenBtn = modal?.querySelector("[data-open]");
    const modalContent = modal?.querySelector(".hs-modal__content");

    function openMobileDialogFromTip(tip) {
      if (!modal || !modalOpenBtn || !modalContent || !tip) return;
      const clone = tip.cloneNode(true);
      clone.removeAttribute("id");
      clone.hidden = false;
      clone.removeAttribute("hidden");
      clone.classList.remove(
        "pos--top",
        "pos--bottom",
        "pos--left",
        "pos--right",
        "is-open"
      );
      clone.style.transform = "none";

      modalContent.innerHTML = "";
      modalContent.appendChild(clone);

      // Abre o dialog do tema (dialog.js trata o evento)
      modalOpenBtn.click();
    }

    // Helpers desktop (tooltip inline)
    function hideTip(tip) {
      if (!tip || tip.hasAttribute("hidden")) return;
      tip.classList.remove("is-open");

      const onEnd = (ev) => {
        if (ev.target !== tip) return;
        tip.removeEventListener("transitionend", onEnd);
        if (!tip.classList.contains("is-open")) tip.setAttribute("hidden", "");
      };
      tip.addEventListener("transitionend", onEnd);

      if (tip._hsCloseTimer) clearTimeout(tip._hsCloseTimer);
      tip._hsCloseTimer = setTimeout(() => {
        if (!tip.classList.contains("is-open")) tip.setAttribute("hidden", "");
      }, 320);
    }

    function closeAll(except = null) {
      root.querySelectorAll(".hs__tooltip").forEach((t) => {
        if (t !== except) hideTip(t);
      });
    }

    // Delegação de clique nos pins
    const onRootClick = (e) => {
      const pin = e.target.closest(".hs__pin");
      if (!pin || !root.contains(pin)) return;

      let tip = pin.nextElementSibling;
      if (!tip || !tip.classList.contains("hs__tooltip")) {
        tip = pin.parentElement?.querySelector?.(".hs__tooltip");
      }
      if (!tip) return;

      if (isMobile()) {
        // MOBILE → abre modal
        openMobileDialogFromTip(tip);
        e.stopPropagation();
        return;
      }

      const isOpen = tip.classList.contains("is-open");
      closeAll(tip);

      if (!isOpen) {
        if (tip._hsCloseTimer) {
          clearTimeout(tip._hsCloseTimer);
          tip._hsCloseTimer = null;
        }
        tip.removeAttribute("hidden");
        // força reflow para transição
        void tip.offsetWidth;
        tip.classList.add("is-open");
      } else {
        hideTip(tip);
      }

      e.stopPropagation();
    };
    offs.push(root.addEventListener("click", onRootClick));

    // Clique fora fecha (desktop)
    const onDocClick = (e) => {
      if (!root.contains(e.target)) closeAll();
    };
    document.addEventListener("click", onDocClick);
    offs.push(() => document.removeEventListener("click", onDocClick));
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeAll();
    };
    root.addEventListener("keydown", onKeyDown);
    offs.push(() => root.removeEventListener("keydown", onKeyDown));
    return {
      unload() {
        offs.forEach((off) => typeof off === "function" ? off() : null);
        closeAll();
      },
    };
  },
});

window.DMSections.register("iwts", {
  init(root) {
    const cleanups = [];

    // ------- helpers de animação -------
    const canWAAPI = !!(Element.prototype && Element.prototype.animate);
    const cancelAnims = (el) => {
      if (el && el.getAnimations) el.getAnimations().forEach((a) => a.cancel());
    };
    const fadeTo = (el, to, dur = 220) => {
      if (!el) return;
      if (!canWAAPI) {
        el.style.opacity = String(to);
        return;
      }
      cancelAnims(el);
      const from = parseFloat(getComputedStyle(el).opacity) || 0;
      el.animate([{ opacity: from }, { opacity: to }], {
        duration: dur,
        easing: "ease",
        fill: "forwards",
      });
    };
    const clipTo = (el, show, dur = 360, effect = "reveal") => {
      if (!el) return;
      if (effect === "fade") {
        fadeTo(el, show ? 1 : 0, show ? 360 : 300);
        return;
      }
      if (!canWAAPI) {
        el.style.opacity = show ? "1" : "0";
        el.style.clipPath = show ? "inset(0 0 0 0)" : "inset(100% 0 0 0)";
        return;
      }
      cancelAnims(el);
      const cs = getComputedStyle(el);
      const fromClip = cs.clipPath || (show ? "inset(100% 0 0 0)" : "inset(0 0 0 0)");
      const toClip = show ? "inset(0 0 0 0)" : "inset(100% 0 0 0)";
      const fromOp = parseFloat(cs.opacity) || (show ? 0 : 1);
      const toOp = show ? 1 : 0;
      el.animate(
        [{ clipPath: fromClip, opacity: fromOp }, { clipPath: toClip, opacity: toOp }],
        { duration: dur, easing: "cubic-bezier(.99,.01,.5,.94)", fill: "forwards" }
      );
    };

    let effect = (root.dataset.effect || "reveal").toLowerCase();
    const supportsClip = CSS && CSS.supports && CSS.supports("clip-path: inset(0 0 0 0)");
    if (effect === "reveal" && !supportsClip) effect = "fade";

    if ("IntersectionObserver" in window) {
      const headIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("is-inview");
              headIO.unobserve(e.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      root.querySelectorAll("[data-appear]").forEach((el) => headIO.observe(el));
      cleanups.push(() => headIO.disconnect());
    } else {
      root.querySelectorAll("[data-appear]").forEach((el) => el.classList.add("is-inview"));
    }

    const dWrap = root.querySelector(".iwts-dpm__desktop");
    if (!dWrap) return; 

    const contentItems = Array.from(dWrap.querySelectorAll(".iwts-dpm__d-content"));
    const mediaSlots = Array.from(dWrap.querySelectorAll(".iwts-dpm__media-slot"));
    const N = Math.min(contentItems.length, mediaSlots.length);
    if (!N) return;

    mediaSlots.forEach((slot, i) => {
      slot.style.position = "absolute";
      slot.style.inset = "0";
      slot.style.willChange = "opacity,clip-path";
      slot.style.zIndex = i === 0 ? "3" : "0";
      slot.style.opacity = i === 0 ? "1" : "0";
      if (effect === "reveal") slot.style.clipPath = i === 0 ? "inset(0 0 0 0)" : "inset(100% 0 0 0)";
    });
    contentItems.forEach((c, i) => c.classList.toggle("is-hidden", i !== 0));

    let active = 0;
    const setActive = (i) => {
      if (i === active || i < 0 || i >= N) return;
      contentItems.forEach((c, idx) => c.classList.toggle("is-hidden", idx !== i));
      mediaSlots.forEach((slot, idx) => {
        if (idx === i) {
          slot.style.zIndex = "3";
          clipTo(slot, true, 360, effect);
        } else {
          slot.style.zIndex = "0";
          clipTo(slot, false, 300, effect);
        }
      });
      active = i;
    };

    const ACT_PCT = 0.32;
    const pickIndex = () => {
      const vh = window.innerHeight || 0;
      const y = vh * ACT_PCT;
      for (let i = 0; i < N; i++) {
        const r = contentItems[i].getBoundingClientRect();
        if (r.top <= y && r.bottom >= y) return i;
      }
      let best = -1,
        bestDist = Infinity;
      for (let i = 0; i < N; i++) {
        const r = contentItems[i].getBoundingClientRect();
        const mid = (r.top + r.bottom) / 2;
        const d = Math.abs(mid - y);
        if (d < bestDist) {
          best = i;
          bestDist = d;
        }
      }
      return best === -1 ? 0 : best;
    };

    let rafId = 0;
    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        setActive(pickIndex());
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    root.querySelectorAll("img").forEach((img) => img.addEventListener("load", onScroll, { passive: true }));
    cleanups.push(() => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      root.querySelectorAll("img").forEach((img) => img.removeEventListener("load", onScroll));
      if (rafId) cancelAnimationFrame(rafId);
    });
    setActive(0);
    onScroll();

    return {
      unload() {
        cleanups.forEach((fn) => fn && fn());
      },
    };
  },

  blockSelect(root, e) {
    const blockId = e.detail?.blockId;
    if (!blockId) return;
    const mobItems = Array.from(root.querySelectorAll(".iwts-dpm__mobile .iwts-dpm__m-item"));
    const el = mobItems.find((n) => n?.dataset?.blockId === blockId);
    if (!el) return;
    const idx = mobItems.indexOf(el);
    if (idx < 0) return;
    const dWrap = root.querySelector(".iwts-dpm__desktop");
    const targets = dWrap ? Array.from(dWrap.querySelectorAll(".iwts-dpm__d-content")) : [];
    const target = targets[idx];
    target?.scrollIntoView?.({ behavior: "smooth", block: "center" });
  },
});

// ======================================================
// MÓDULO 5: Imagens e Texto Rolando (data-section-type="iwts")
// ======================================================
window.DMSections.register("iwts", {
  init(root) {
    const cleanups = [];

    // ------- helpers de animação -------
    const canWAAPI = !!(Element.prototype && Element.prototype.animate);
    const cancelAnims = (el) => {
      if (el && el.getAnimations) el.getAnimations().forEach((a) => a.cancel());
    };
    const fadeTo = (el, to, dur = 220) => {
      if (!el) return;
      if (!canWAAPI) {
        el.style.opacity = String(to);
        return;
      }
      cancelAnims(el);
      const from = parseFloat(getComputedStyle(el).opacity) || 0;
      el.animate([{ opacity: from }, { opacity: to }], {
        duration: dur,
        easing: "ease",
        fill: "forwards",
      });
    };
    const clipTo = (el, show, dur = 360, effect = "reveal") => {
      if (!el) return;
      if (effect === "fade") {
        fadeTo(el, show ? 1 : 0, show ? 360 : 300);
        return;
      }
      if (!canWAAPI) {
        el.style.opacity = show ? "1" : "0";
        el.style.clipPath = show ? "inset(0 0 0 0)" : "inset(100% 0 0 0)";
        return;
      }
      cancelAnims(el);
      const cs = getComputedStyle(el);
      const fromClip = cs.clipPath || (show ? "inset(100% 0 0 0)" : "inset(0 0 0 0)");
      const toClip = show ? "inset(0 0 0 0)" : "inset(100% 0 0 0)";
      const fromOp = parseFloat(cs.opacity) || (show ? 0 : 1);
      const toOp = show ? 1 : 0;
      el.animate(
        [{ clipPath: fromClip, opacity: fromOp }, { clipPath: toClip, opacity: toOp }],
        { duration: dur, easing: "cubic-bezier(.99,.01,.5,.94)", fill: "forwards" }
      );
    };

    // ------- efeito desejado -------
    let effect = (root.dataset.effect || "reveal").toLowerCase();
    const supportsClip = CSS && CSS.supports && CSS.supports("clip-path: inset(0 0 0 0)");
    if (effect === "reveal" && !supportsClip) effect = "fade";

    // ------- revelar headings com [data-appear] -------
    if ("IntersectionObserver" in window) {
      const headIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("is-inview");
              headIO.unobserve(e.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      root.querySelectorAll("[data-appear]").forEach((el) => headIO.observe(el));
      cleanups.push(() => headIO.disconnect());
    } else {
      root.querySelectorAll("[data-appear]").forEach((el) => el.classList.add("is-inview"));
    }

    // ------- Desktop wiring -------
    const dWrap = root.querySelector(".iwts-dpm__desktop");
    if (!dWrap) return; // mobile não precisa de JS

    const contentItems = Array.from(dWrap.querySelectorAll(".iwts-dpm__d-content"));
    const mediaSlots = Array.from(dWrap.querySelectorAll(".iwts-dpm__media-slot"));
    const N = Math.min(contentItems.length, mediaSlots.length);
    if (!N) return;

    // estado inicial
    mediaSlots.forEach((slot, i) => {
      slot.style.position = "absolute";
      slot.style.inset = "0";
      slot.style.willChange = "opacity,clip-path";
      slot.style.zIndex = i === 0 ? "3" : "0";
      slot.style.opacity = i === 0 ? "1" : "0";
      if (effect === "reveal") slot.style.clipPath = i === 0 ? "inset(0 0 0 0)" : "inset(100% 0 0 0)";
    });
    contentItems.forEach((c, i) => c.classList.toggle("is-hidden", i !== 0));

    let active = 0;
    const setActive = (i) => {
      if (i === active || i < 0 || i >= N) return;
      contentItems.forEach((c, idx) => c.classList.toggle("is-hidden", idx !== i));
      mediaSlots.forEach((slot, idx) => {
        if (idx === i) {
          slot.style.zIndex = "3";
          clipTo(slot, true, 360, effect);
        } else {
          slot.style.zIndex = "0";
          clipTo(slot, false, 300, effect);
        }
      });
      active = i;
    };

    // escolhe item pela posição na tela (ponto de 32% da viewport)
    const ACT_PCT = 0.32;
    const pickIndex = () => {
      const vh = window.innerHeight || 0;
      const y = vh * ACT_PCT;
      for (let i = 0; i < N; i++) {
        const r = contentItems[i].getBoundingClientRect();
        if (r.top <= y && r.bottom >= y) return i;
      }
      // fallback: mais próximo
      let best = -1,
        bestDist = Infinity;
      for (let i = 0; i < N; i++) {
        const r = contentItems[i].getBoundingClientRect();
        const mid = (r.top + r.bottom) / 2;
        const d = Math.abs(mid - y);
        if (d < bestDist) {
          best = i;
          bestDist = d;
        }
      }
      return best === -1 ? 0 : best;
    };

    // listeners (scroll/resize/load)
    let rafId = 0;
    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        setActive(pickIndex());
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    root.querySelectorAll("img").forEach((img) => img.addEventListener("load", onScroll, { passive: true }));
    cleanups.push(() => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      root.querySelectorAll("img").forEach((img) => img.removeEventListener("load", onScroll));
      if (rafId) cancelAnimationFrame(rafId);
    });

    // inicializa
    setActive(0);
    onScroll();

    return {
      unload() {
        cleanups.forEach((fn) => fn && fn());
      },
    };
  },

  // (opcional) focar item ao selecionar bloco no editor
  blockSelect(root, e) {
    const blockId = e.detail?.blockId;
    if (!blockId) return;

    // usamos o item mobile (tem shopify_attributes) pra descobrir o índice
    const mobItems = Array.from(root.querySelectorAll(".iwts-dpm__mobile .iwts-dpm__m-item"));
    const el = mobItems.find((n) => n?.dataset?.blockId === blockId);
    if (!el) return;

    const idx = mobItems.indexOf(el);
    if (idx < 0) return;

    // rola até o conteúdo correspondente na coluna de texto
    const dWrap = root.querySelector(".iwts-dpm__desktop");
    const targets = dWrap ? Array.from(dWrap.querySelectorAll(".iwts-dpm__d-content")) : [];
    const target = targets[idx];
    target?.scrollIntoView?.({ behavior: "smooth", block: "center" });
  },
});

// ======================================================
// MÓDULO 6: Várias imagens com texto (data-section-type="miwt")
// ======================================================
window.DMSections.register("miwt", {
  init(root) {
    // helper local (caso seu arquivo já tenha um "on", pode usar o global)
    const on = (el, ev, fn, opt) => (el && el.addEventListener(ev, fn, opt), () => el && el.removeEventListener(ev, fn, opt));
    const offs = [];

    const imageList   = root.querySelector('[data-role="image-list"]');
    const images      = Array.from(imageList?.querySelectorAll('img[id]') || []);
    const contentList = root.querySelector('[data-role="content-list"]');
    const slides      = Array.from(contentList?.querySelectorAll('.dm-miwt__slide') || []);
    const btnPrev     = root.querySelector('[data-prev]');
    const btnNext     = root.querySelector('[data-next]');
    const layout      = root.getAttribute('data-layout') || 'stacked';

    if (!slides.length) return;

    let index = 0;

    function select(idx){
      index = (idx + slides.length) % slides.length;

      // conteúdo
      slides.forEach((s,i)=> s.classList.toggle('is-selected', i === index));

      // imagem vinculada
      const id = slides[index].getAttribute('image-id');
      if (layout === 'stacked') {
        if (id) {
          images.forEach(img => {
            img.classList.toggle('is-selected', img.id === id);
            // o CSS só "esconde" por classe em >=700px, mobile fica ok
          });
        } else {
          images.forEach((img,i)=> img.classList.toggle('is-selected', i === 0));
        }
      } else {
        // collage/scattered: não escondemos imagens; só destaca a principal
        if (id) {
          images.forEach(img=>{
            if (img.id === id) {
              // evita duplicar o translateY
              const t = img.style.transform || '';
              if (!t.includes(' translateY(-2px)')) img.style.transform = t + ' translateY(-2px)';
              img.style.opacity = '1';
            } else {
              img.style.transform = (img.style.transform || '').replace(' translateY(-2px)','');
              img.style.opacity = '';
            }
          });
        }
      }
    }

    // estado inicial (garante imagem marcada no load)
    (function initSelected(){
      const firstId = slides[0].getAttribute('image-id');
      if (layout === 'stacked' && images.length){
        images.forEach(img => img.classList.remove('is-selected'));
        const firstMatch = images.find(i => i.id === firstId) || images[0];
        firstMatch && firstMatch.classList.add('is-selected');
      }
      select(0);
    })();

    // navegação
    if (btnPrev) offs.push(on(btnPrev, 'click', ()=> select(index - 1)));
    if (btnNext) offs.push(on(btnNext, 'click', ()=> select(index + 1)));

    // teclado (quando focado na seção)
    const onKey = (e)=>{
      if (e.key === 'ArrowLeft')  { e.preventDefault(); btnPrev?.click(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); btnNext?.click(); }
    };
    offs.push(on(root, 'keydown', onKey));

    return {
      unload() { offs.forEach(off => off && off()); }
    };
  },

  // Suporte ao editor do tema (foca o slide clicado no customizer)
  blockSelect(root, e) {
    const blockId = e.detail?.blockId;
    if (!blockId) return;
    const slides = Array.from(root.querySelectorAll('.dm-miwt__slide'));
    const idx = slides.findIndex(s => s?.dataset?.blockId === blockId);
    if (idx >= 0) {
      // aciona a seleção pela mesma lógica do init
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      // usa um pequeno truque para chegar no índice desejado:
      // calcula diferença a partir do slide atualmente selecionado
      const cur = slides.findIndex(s => s.classList.contains('is-selected'));
      const delta = (idx - (cur < 0 ? 0 : cur));
      if (delta !== 0) {
        const btn = delta > 0 ? next : prev;
        const clicks = Math.abs(delta);
        for (let i = 0; i < clicks; i++) btn?.click();
      }
      slides[idx].scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
    }
  }
});

// ======================================================
// MÓDULO: Blocos de imagens (data-section-type="image-link-blocks")
// ======================================================
window.DMSections.register("image-link-blocks", {
  init(root) {
    // helper local (se já tiver um "on" global, pode usar o global)
    const on = (el, ev, fn, opt) => (el && el.addEventListener(ev, fn, opt), () => el && el.removeEventListener(ev, fn, opt));
    const offs = [];

    const scroller = root.querySelector(".ilb-scroller");
    const prev = root.querySelector(".ilb-ctrl--prev");
    const next = root.querySelector(".ilb-ctrl--next");
    if (!scroller) return;

    // gap seguro (columnGap > gap; fallback 0)
    const getGap = () => {
      const cs = getComputedStyle(scroller);
      const g1 = parseFloat(cs.columnGap || "0");
      const g2 = parseFloat(cs.gap || "0");
      return Number.isFinite(g1) && g1 > 0 ? g1 : (Number.isFinite(g2) ? g2 : 0);
    };

    const getStep = () => {
      const item = scroller.querySelector(".ilb-item");
      if (!item) return 300;
      const w = item.getBoundingClientRect().width || 300;
      return w + getGap();
    };

    let rafId = 0;
    const update = () => {
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const left = scroller.scrollLeft;
      if (prev) prev.disabled = left <= 0;
      if (next) next.disabled = left >= max - 1;
    };
    const onScroll = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    // clicks
    if (prev) offs.push(on(prev, "click", () => scroller.scrollBy({ left: -getStep(), behavior: "smooth" })));
    if (next) offs.push(on(next, "click", () => scroller.scrollBy({ left:  getStep(), behavior: "smooth" })));

    // scroll/resize/imagens
    scroller.addEventListener("scroll", onScroll, { passive: true });
    offs.push(() => scroller.removeEventListener("scroll", onScroll));
    offs.push(on(window, "resize", update, { passive: true }));
    scroller.querySelectorAll("img").forEach(img => offs.push(on(img, "load", update, { passive: true })));

    // estado inicial
    update();

    return {
      unload() {
        offs.forEach(off => off && off());
        if (rafId) cancelAnimationFrame(rafId);
      },
    };
  },

  // Faz o editor focar/rolar até o bloco selecionado
  blockSelect(root, e) {
    const blockId = e.detail?.blockId;
    if (!blockId) return;
    const scroller = root.querySelector(".ilb-scroller");
    const card = scroller?.querySelector(`.ilb-item[data-block-id="${blockId}"]`);
    if (!scroller || !card) return;

    // centra aproximadamente o item no scroller
    const targetLeft = card.offsetLeft - (scroller.clientWidth - card.clientWidth) / 2;
    scroller.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });

    // feedback visual rápido (opcional)
    card.classList.add("is-selected-temp");
    setTimeout(() => card.classList.remove("is-selected-temp"), 600);
  },
});
// ======================================================
// MÓDULO: Timeline (data-section-type="timeline")
// ======================================================
window.DMSections.register("timeline", {
  init(root) {
    const offs = [];
    const on = (el, ev, fn, opt) => (el && el.addEventListener(ev, fn, opt), () => el && el.removeEventListener(ev, fn, opt));
    const raf = (fn) => requestAnimationFrame(fn);

    const slider = root.querySelector(".dm-tl-slider");
    const slides = Array.from(root.querySelectorAll(".dm-tl-slide"));
    const nav = root.querySelector(".dm-tl-nav");
    const navBtns = nav ? Array.from(nav.querySelectorAll(".dm-tl-nav-item")) : [];
    const prevBtn = root.querySelector(".dm-tl-prev");
    const nextBtn = root.querySelector(".dm-tl-next");
    const effectAttr = root.querySelector(".dm-tl")?.getAttribute("data-dm-tl-effect") || "reveal";

    if (!slider || slides.length === 0) return;

    let index = 0;
    let ro = null;

    // ----- helpers
    const setHeight = () => {
      const active = slides[index];
      if (!active) return;
      slider.style.maxHeight = active.offsetHeight + "px";
    };

    const updateButtons = () => {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    };

    const updateNav = () => {
      navBtns.forEach((btn) => {
        const i = parseInt(btn.getAttribute("data-index") || "-1", 10);
        btn.setAttribute("aria-current", i === index ? "true" : "false");
      });
      // manter botão atual visível no carrossel de rótulos (mobile)
      if (nav) {
        const current = nav.querySelector('.dm-tl-nav-item[aria-current="true"]');
        if (current) {
          const c = current.getBoundingClientRect();
          const n = nav.getBoundingClientRect();
          if (c.left < n.left || c.right > n.right) {
            nav.scrollBy({ left: c.left - n.left - 24, behavior: "smooth" });
          }
        }
      }
    };

    const eagerNeighbors = (i) => {
      [i - 1, i + 1].forEach((j) => {
        if (!slides[j]) return;
        slides[j].querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = "eager"; });
      });
    };

    const select = (i) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (i === index) return;

      const from = slides[index];
      const to = slides[i];

      if (from) from.classList.remove("is-active");
      if (to) to.classList.add("is-active");

      index = i;
      setHeight();
      updateButtons();
      updateNav();
      eagerNeighbors(index);
    };

    // ----- init visual
    slides.forEach((s, idx) => s.classList.toggle("is-active", idx === 0));
    // “forçar” CSS a aplicar o efeito correto logo de cara
    root.querySelector(".dm-tl")?.setAttribute("data-dm-tl-effect", effectAttr);

    // altura reativa
    ro = new ResizeObserver(() => setHeight());
    ro.observe(slider);

    // teclado
    offs.push(on(root, "keydown", (ev) => {
      if (ev.key === "ArrowLeft") { ev.preventDefault(); select(index - 1); }
      if (ev.key === "ArrowRight") { ev.preventDefault(); select(index + 1); }
    }));

    // botões prev/next
    if (prevBtn) offs.push(on(prevBtn, "click", () => select(index - 1)));
    if (nextBtn) offs.push(on(nextBtn, "click", () => select(index + 1)));

    // navegação por rótulos
    navBtns.forEach((btn) => {
      const h = () => {
        const i = parseInt(btn.getAttribute("data-index") || "0", 10);
        select(i);
      };
      offs.push(on(btn, "click", h));
    });

    // imagens podem alterar altura
    root.querySelectorAll("img").forEach((img) => offs.push(on(img, "load", () => raf(setHeight), { passive: true })));

    // primeira pintura
    requestAnimationFrame(() => {
      setHeight();
      updateButtons();
      updateNav();
      eagerNeighbors(0);
    });

    return {
      unload() {
        offs.forEach((off) => off && off());
        if (ro) ro.disconnect();
      },
    };
  },

  // Seleção de bloco no editor do tema: foca o slide correspondente
  blockSelect(root, e) {
    const blockId = e.detail?.blockId;
    if (!blockId) return;
    const slides = Array.from(root.querySelectorAll(".dm-tl-slide"));
    const idx = slides.findIndex((s) => s.matches(`[data-block-id="${blockId}"]`));
    if (idx === -1) return;

    // simula navegação: liga o slide, atualiza nav e altura
    const navBtn = root.querySelector(`.dm-tl-nav-item[data-index="${idx}"]`);
    navBtn?.click();
    slides[idx].scrollIntoView?.({ block: "nearest", behavior: "smooth" });
  },
});

})();
